import { useAtomValue } from "jotai";
import { ReactNode, useRef } from "react";

import { useAppliedLanguage } from "./LanguagePreferenceProvider";
import { effectiveLanguageAtom } from "./atoms";
import { useActiveClubLanguage } from "./useActiveClubLanguage";

type ActiveClubLanguageProviderProps = {
  active?: boolean;
  children: ReactNode;
  locale?: string | null;
};

export const ActiveClubLanguageProvider = ({
  active = true,
  children,
  locale,
}: ActiveClubLanguageProviderProps) => {
  const sourceIsRegistered = useActiveClubLanguage(locale, active);
  const appliedLanguage = useAppliedLanguage();
  const effectiveLanguage = useAtomValue(effectiveLanguageAtom);
  const hasRenderedChildren = useRef(false);

  if (sourceIsRegistered && appliedLanguage === effectiveLanguage) {
    hasRenderedChildren.current = true;
  }

  return hasRenderedChildren.current ? children : null;
};
